<template>
  <div>
    <!-- <APPOINTMENTS BY TODAY TOGGLE> -->
    <label class="switch">
      <input
        type="checkbox"
        checked
        @click="onlyUnsolvedReports = !onlyUnsolvedReports; getFailures()"
      >
      <span class="slider round"></span>
    </label>
    <p v-if="onlyUnsolvedReports == true" style="display:inline-block">Nerješeni prijavljeni kvarovi</p>
    <!-- </APPOINTMENTS BY TODAY TOGGLE> -->
    <!-- <FAILURE DETAILS DIALOG> -->
    <v-dialog v-model="failureDialog" max-width="590">
      <v-card>
        <v-card-text>
          <failure-details
            @closeDialog="failureDialog = false"
            @failureSolved="getFailures"
            :failureDialog="failureDialog"
            :failureId="selectedFailure"
          ></failure-details>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- </FAILURE DETAILS DIALOG> -->
    <!-- <FAILURE DATA LIST> -->
    <v-container>
      <v-data-table :headers="headers" :items="reports.Failures" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.ReportDate }}</td>
          <td class="text-xs-left">{{ props.item.ReportTime }}</td>
          <td class="text-xs-left">{{ props.item.ReportedBy }}</td>
          <td class="text-xs-left">{{ props.item.Studio }}</td>
          <td class="text-xs-center">
            <img
              @click="openFailureDetails(props.item.FailureId)"
              class="action-icon-sm"
              src="../../assets/icons/details.png"
              alt="Detalji"
            >
          </td>
        </template>
      </v-data-table>
      <!-- </FAILURE DATA LIST> -->
    </v-container>
    <!-- <PAGINATION> -->
    <div class="text-xs-center pagination">
      <v-pagination :total-visible="5" @input="getFailures" v-model="selectedPage" :length="numberOfPages"></v-pagination>
    </div>
    <!-- </PAGINATION> -->
  </div>
</template>

<script>
import FailureDetails from "./Details";
export default {
  components: {
    failureDetails: FailureDetails
  },
  data() {
    return {
      reports: [],
      onlyUnsolvedReports: true,
      failureDialog: false,
      selectedFailure: null,
      headers: [
        {
          text: "Datum",
          value: "datum",
          align: "left"
        },
        {
          text: "Vrijeme",
          value: "vrijeme",
          align: "left"
        },
        {
          text: "Studio",
          value: "studio",
          align: "left"
        },
        {
          text: "Prijavio",
          value: "prijavio",
          align: "left"
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "left"
        }
      ],

      //Pagination
      numberOfPages: 1,
      selectedPage: 1
    };
  },
  methods: {
    getFailures() {
      this.$store.state.services.failureService
        .failureList(this.selectedPage, this.onlyUnsolvedReports)
        .then(response => {
          this.numberOfPages = response.data.NumberOfPages;
          this.reports = response.data;
        });
    },
    openFailureDetails(failureId) {
      this.failureDialog = true;
      this.selectedFailure = failureId;
    }
  },
  created() {
    this.getFailures();
  }
};
</script>

<style scoped>
.pagination {
  position: absolute;
  bottom: 0;
  margin: 30px 0;
  width: 100%;
}
</style>
